module.exports = __webpack_public_path__ + "static/img/erweima.afca3cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/erweima.png
// module id = d0rm
// module chunks = 5